class IdoniaError {
  static get UNKNOWN_TYPE () { return 'unknown' }
  static get VALIDATION_TYPE () { return 'validation' }
  static get API_TYPE () { return 'api' }

  constructor (message, severity, type, code) {
    this.message = message
    this.severity = severity || 6
    this.type = type || IdoniaError.UNKNOWN_TYPE
    this.code = code || 'NOCODE'
  }
}

export default IdoniaError



// WEBPACK FOOTER //
// ./src/error/IdoniaError.js